import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Disclaimer from "./Disclaimer";
import RouteCard from "./RouteCard";
import BottomNav from "./BottomNav";
import ShareModal from "./ShareModal";
import InfoModal from "./InfoModal";

const CityRoutes = () => {
  // Access the locationId parameter from the URL
  const { locationId } = useParams();

  const [location, setLocation] = useState([]);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  useEffect(() => {
    let isMounted = true;
    setLoader(true);
    const fetchLocation = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_LOCATIONS + "/" + locationId);
        if (isMounted) {
          setLocation(response.data.data);
          console.log(response.data.data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || "Something went wrong");
        }
        console.error("Error:", err);
      }
    };

    fetchLocation();

    return () => {
      isMounted = false; // Cleanup: prevent setting state if component is unmounted
    };
  }, []);

  // If the location doesn't exist, return a not found message
  if (!location) {
    return <h1>Location Not Found</h1>;
  }

  return (
    <>
      <Disclaimer disclaimerModal={disclaimerModal} setDisclaimerModal={setDisclaimerModal} />
      <div id="routes-list">
        {location.length && (
          <>
            <h2 style={{ color: "#fff", fontSize: 26, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,marginBottom:34 }}>
              <svg style={{ maxWidth: 25, height: "auto" }} width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.4">
                  <path d="M0 8.84558V7.19065C4.11464 7.19065 9.33293 1.03481 9.43511 0L11.09 0.0109262C11.09 2.04994 4.93145 8.84558 0 8.84558Z" fill="white" />
                  <path d="M20.5246 8.84558C15.5931 8.84558 9.43457 2.04994 9.43457 0.0109253H11.09C11.1917 1.03481 16.41 7.19065 20.5246 7.19065V8.84558Z" fill="white" />
                  <path d="M9.79735 1.88609L2.58102 7.66604C2.40563 7.80427 2.30292 8.01571 2.30292 8.23972V16.9924C2.30292 17.6464 2.83398 18.1764 3.48797 18.1764H6.77816C6.97266 18.1764 7.15843 18.0993 7.29556 17.9622C7.43215 17.8251 7.50974 17.6393 7.50974 17.4454V12.0998C7.50974 11.6971 7.83646 11.3687 8.24077 11.3687H12.2838C12.4783 11.3687 12.6636 11.4458 12.8007 11.5829C12.9378 11.72 13.0149 11.9058 13.0149 12.0998V17.441C13.0149 17.6349 13.0919 17.8207 13.229 17.9578C13.3662 18.095 13.5519 18.172 13.7464 18.172H17.0366C17.6906 18.172 18.2217 17.642 18.2217 16.988V8.23972C18.2206 8.01407 18.1146 7.80263 17.9365 7.6655L10.7202 1.88554C10.4513 1.66755 10.0662 1.66755 9.79735 1.88554V1.88609Z" fill="white" />
                </g>
              </svg>

              <span> Locations</span>
            </h2>
            <p style={{ fontSize: 18, color: "#FFFFFFBF", textAlign: "center", marginBottom: 18 }}>Whose voice do you want to hear, and where might it take you?</p>
          </>
        )}

        {location && location.map((location) => <RouteCard status={location.status} key={location.id} text={location.text} stops={location.stops} title={location.title} image={location.image} distance={location.distance} url={`/city-route/${location.id}`} />)}
      </div>

      {!disclaimerModal && (
        <BottomNav
          activeIcon={shareModal ? "share" : infoModal ? "info" : "home"}
          onInfoClick={() => setInfoModal(true)}
          onShareClick={() => setShareModal(true)}
          onClose={() => {
            setShareModal(false);
            setInfoModal(false);
          }}
        />
      )}
      <ShareModal shareModal={shareModal} setShareModal={setShareModal} />
      <InfoModal infoModal={infoModal} setInfoModal={setInfoModal} />
    </>
  );
};

export default CityRoutes;
